import React, { useMemo, useRef } from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const { Col, Row } = designSystem;

const GridContainer = ({ containerBounds, columnGap, scrollPosition, columnsCount }) => {
  const gridView = useRef(null);
  const columns = useMemo(() => {
    const className = classNames('ws-grid-view__column', {
      'ws-grid-view__column--with-border': columnGap < 2,
    });
    const cols = [];
    while (cols.length < columnsCount) {
      cols.push(
        <Col>
          <div className={className} />
        </Col>
      );
    }

    return cols;
  }, [columnGap, columnsCount]);

  const { left, width } = containerBounds;

  return (
    <div
      className="ws-grid-view"
      ref={gridView}
      style={{
        top: `${scrollPosition}px`,
        left: `${left + columnGap / 2}px`,
        width: `${width - columnGap}px`,
      }}
    >
      <Row style={{ '--bs-gutter-x': `${columnGap}px` }}>{columns}</Row>
    </div>
  );
};

GridContainer.propTypes = {
  containerBounds: PropTypes.shape({
    left: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }).isRequired,
  columnGap: PropTypes.number.isRequired,
  scrollPosition: PropTypes.number.isRequired,
  columnsCount: PropTypes.number.isRequired,
};

export default GridContainer;
